import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { uploadFile } from './utils';

export default function* listenUploadFile() {
  yield takeEvery(actions.uploadFile.type, uploadFile);
}
